var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClient = function SvgClient(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 262",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "client_svg__a",
    cx: 125,
    cy: 125,
    r: 125
  }), /*#__PURE__*/React.createElement("circle", {
    id: "client_svg__c",
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("filter", {
    id: "client_svg__e"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "client_svg__b",
    width: 250,
    height: 250,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#client_svg__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#client_svg__a",
    stroke: "#00D4C1",
    strokeDasharray: "5 5",
    strokeWidth: 2,
    mask: "url(#client_svg__b)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "client_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#client_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#client_svg__c",
    fill: "#EDF2FF"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#client_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDDA5",
    d: "M172.757 176.798a44.45 44.45 0 0 0-24.57-17.524l-23.188-6.495v-16.666c9.803-7.364 16.24-18.95 16.635-32.058a11.1 11.1 0 0 0 4.477.946c6.136 0 11.111-4.974 11.111-11.111s-4.975-11.111-11.111-11.111c-1.582 0-3.083.335-4.444.93v-3.152c0-23.013-18.656-41.667-41.667-41.667S58.332 57.544 58.332 80.557v3.152a11.1 11.1 0 0 0-4.444-.93c-6.137 0-11.111 4.974-11.111 11.111s4.974 11.111 11.11 11.111c1.595 0 3.107-.342 4.477-.946.395 13.107 6.833 24.694 16.634 32.058v16.666l-23.186 6.495a44.44 44.44 0 0 0-24.57 17.524l-16.131 23.336v16.534h177.778v-16.534z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7A74F",
    d: "M99.999 144.445a41.6 41.6 0 0 1-14.6-2.636 41.4 41.4 0 0 0 22.378 6.525 41.5 41.5 0 0 0 17.222-3.728v-8.493a41.5 41.5 0 0 1-25 8.332"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00004D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.12,
    d: "M59.782 95.511a6.111 6.111 0 0 0-8.272-7.252m88.707 7.252a6.111 6.111 0 0 1 8.274-7.252"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#client_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.111 118.894c0 6.136-4.974 11.11-11.11 11.11-6.137 0-11.112-4.974-11.112-11.11z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#00004D",
    mask: "url(#client_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.778 95.555a4.445 4.445 0 1 1-8.89 0 4.445 4.445 0 0 1 8.89 0m-36.667 0a4.445 4.445 0 1 1-8.892.002 4.445 4.445 0 0 1 8.893-.003"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#00004D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.12,
    mask: "url(#client_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.999 91.111 105.555 110l-7.778 1.111"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#091F4F",
    mask: "url(#client_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.425 85.877a11.07 11.07 0 0 1 6.02-2.961v-21.96a22.23 22.23 0 0 0-12.284-19.876l-27.192-13.595a11.1 11.1 0 0 0-9.938 0L67.84 41.08a22.22 22.22 0 0 0-12.284 19.877v21.959c2.32.35 4.402 1.41 6.02 2.961v-.241a18.494 18.494 0 0 1 27.2-16.314 23.84 23.84 0 0 0 22.448 0 18.494 18.494 0 0 1 27.201 16.314z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#client_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00D4C1",
    d: "m188.889 200.134-16.131-23.337a44.45 44.45 0 0 0-24.571-17.523l-20.41-5.718v-11.89a2.777 2.777 0 0 0-2.777-2.777v2.78c-6.964 5.23-15.62 8.332-25 8.332s-18.036-3.101-25-8.332v-2.78a2.78 2.78 0 0 0-2.778 2.778v11.889l-20.409 5.718a44.44 44.44 0 0 0-24.57 17.523l-16.132 23.336v16.534h177.778z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00004D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.12,
    d: "M114.699 161.501a41.6 41.6 0 0 1-14.7 2.666c-10.671 0-20.407-4.012-27.779-10.611"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#091F4F",
    mask: "url(#client_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m109.92 129.152-4.342 2.52a11.11 11.11 0 0 1-11.156 0l-4.343-2.52a5.56 5.56 0 0 1-2.456-6.636l.746-2.137a2.22 2.22 0 0 1 2.098-1.49h19.066c.945 0 1.787.598 2.098 1.49l.746 2.137a5.56 5.56 0 0 1-2.456 6.636m27.979-27.795-2.875 9.382a16.67 16.67 0 0 1-10.567 10.896l-5.346 1.818-2.138-4.215a11.11 11.11 0 0 0-9.91-6.085H92.935a11.11 11.11 0 0 0-9.91 6.085l-2.137 4.215-5.346-1.818a16.67 16.67 0 0 1-10.568-10.896l-2.874-9.382a11.1 11.1 0 0 1-3.766 2.713V125c0 23.012 18.654 41.667 41.666 41.667s41.667-18.655 41.667-41.667v-20.93a11.1 11.1 0 0 1-3.767-2.713"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 242.5,
    r: 19.5,
    fill: "#346BE9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#client_svg__e)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.196 239.251 2.826-2.815v8.464c0 .549.445.974.978.974a.973.973 0 0 0 .978-.974v-8.465l2.826 2.816a.97.97 0 0 0 .693.283.97.97 0 0 0 .693-.283.96.96 0 0 0 0-1.382l-4.497-4.497a.97.97 0 0 0-1.387 0l-4.496 4.498a.96.96 0 0 0 0 1.381c.373.372.995.372 1.387 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.898 244.014a.973.973 0 0 0-.978.974v2.976h-11.822v-2.976a.973.973 0 0 0-.978-.974.985.985 0 0 0-.978.974v3.95c0 .549.445.973.978.973h13.778a.973.973 0 0 0 .978-.974v-3.949a.974.974 0 0 0-.978-.974"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClient);
export default ForwardRef;